'use client';

import { Button } from '@ui/components/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/components/card';
import { Input } from '@ui/components/input';
import { Label } from '@ui/components/label';
import { text as sharedText } from '@shared/text';
import { text } from '@modules/forgot-password/text';

import type { ForgotPasswordProps } from './forgot_password_view_props';
export type { ForgotPasswordProps } from './forgot_password_view_props';

export function ForgotPasswordForm({
  step,
  title,
  subtitle,
  submitButtonLabel,
  cancelLabel,
  emailLabel,
  codeLabel,
  newPasswordLabel,
  isSubmitting,
  email,
  code,
  newPassword,
  onEmailChange,
  onCodeChange,
  onNewPasswordChange,
  onCancel,
  onFormSubmit,
}: ForgotPasswordProps) {
  return (
    <Card className="w-full max-w-md py-5">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">{title}</CardTitle>
        <CardDescription>{subtitle}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-5">
        <form onSubmit={onFormSubmit} className="flex flex-col gap-4">
          {step === 'request' ? (
            <div className="flex flex-col gap-2">
              <Label htmlFor="email">{emailLabel}</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(event) => onEmailChange(event.target.value)}
                placeholder={sharedText.emailPlaceholder}
                autoCapitalize="none"
                autoComplete="email"
                disabled={isSubmitting}
              />
            </div>
          ) : (
            <>
              <div className="flex flex-col gap-2">
                <Label htmlFor="code">{codeLabel}</Label>
                <Input
                  id="code"
                  value={code}
                  onChange={(event) => onCodeChange(event.target.value)}
                  placeholder={text.codePlaceholder}
                  autoCapitalize="none"
                  disabled={isSubmitting}
                />
              </div>

              <div className="flex flex-col gap-2">
                <Label htmlFor="newPassword">{newPasswordLabel}</Label>
                <Input
                  id="newPassword"
                  type="password"
                  value={newPassword}
                  onChange={(event) => onNewPasswordChange(event.target.value)}
                  placeholder={text.newPasswordPlaceholder}
                  autoComplete="new-password"
                  disabled={isSubmitting}
                />
              </div>
            </>
          )}

          <Button type="submit" className="w-full" size="lg" disabled={isSubmitting}>
            {submitButtonLabel}
          </Button>
        </form>

        <div className="flex justify-center">
          <Button type="button" variant="link" disabled={isSubmitting} onClick={onCancel}>
            {cancelLabel}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
